import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogComponent } from "@/lib/Components/Dialog/Hooks/useDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { AgreementTemplateInput } from "@/app/ProDrivers/Agreements/Components/AgreementTemplateInput";
import { useGqlMutation, useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { createProDriverAgreement } from "@/app/ProDrivers/Agreements/GraphQL/agreementMutations";
import { proDriverAgreementTemplateListQuery } from "@/app/ProDrivers/Agreements/GraphQL/agreementTemplateQueries";
import { z } from "zod";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";

const createAgreementValidation = z.object({
  template_id: z.string().min(1, "Choose a template"),
});

type CreateAgreementFormValues = z.infer<typeof createAgreementValidation>;

export const CreateAgreementDialog: DialogComponent<
  { workOrderAssignmentId: string },
  string
> = ({ workOrderAssignmentId }) => {
  const { close, resolve } = useDialogState<string>();
  const { data } = useGqlQuery(proDriverAgreementTemplateListQuery, {});
  const { mutateAsync } = useGqlMutation(createProDriverAgreement);

  const templates = data?.proDriverAgreementTemplates ?? [];

  return (
    <BaseDialog
      title="New agreement"
      subtitle="Drive and driver details are filled in from this assignment. You can edit the wording before sending."
    >
      <GenericForm<CreateAgreementFormValues>
        initialValues={{ template_id: templates[0]?.id ?? "" }}
        validationSchema={toFormikValidationSchema(createAgreementValidation)}
        onSubmit={async (values) => {
          const res = await mutateAsync({
            input: {
              work_order_assignment_id: workOrderAssignmentId,
              template_id: values.template_id,
            },
          });

          resolve?.(res.createProDriverAgreement.id);

          await close();
        }}
      >
        <AgreementTemplateInput
          name="template_id"
          label="Template"
          className="col-span-full"
        />
        <DialogSubmitButton text="Create draft" />
      </GenericForm>
    </BaseDialog>
  );
};
